import { render } from "./ConfirmModal.vue?vue&type=template&id=d486a96c"
const script = {}

import "./ConfirmModal.vue?vue&type=style&index=0&id=d486a96c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__